import {
  BookingData,
  BookingOfferPrice
} from '@daedalus/core/src/booking/types/BookingData'

import {Offer, OfferPrice} from '../offer/types/offer'
import {OfferCheckAPIResponseWithAdaptedRoom} from '../offer/types/OfferCheck'
import {convertPricesToNewFormat} from '../price/business/price'

// A type-guard function that checks if the given argument is valid booking data
export const isExistingBooking = (
  bookingData?: OfferCheckAPIResponseWithAdaptedRoom | Offer | BookingData
): bookingData is BookingData => {
  return !!(bookingData as BookingData)?.confirmationId
}

/**
 * Converts booking price to a uniform offer price format.
 * Facilitates consistent pricing display across components by standardizing format differences between booking and offer prices.
 * @returns OfferPrice - The converted price
 * @param prices
 */
export const convertBookingPriceToOfferPrice = (
  prices: BookingOfferPrice[]
): OfferPrice[] => {
  return prices.map(price => {
    const convertedPrice = convertPricesToNewFormat(price)

    const chargeable =
      convertedPrice.chargeable as BookingOfferPrice['chargeable']
    const {hotelFees} = convertedPrice

    const convertedChargeable = {
      ...convertedPrice.chargeable,
      total: Number(chargeable.total),
      base: Number(chargeable.base),
      taxes: Number(chargeable.taxes),
      currencyCode: chargeable.currency
    }

    const convertedHotelFees = {
      ...hotelFees,
      total: Number(hotelFees.total),
      breakdown: hotelFees.breakdown?.map(fee => ({
        ...fee,
        total: Number(fee.total)
      })),
      currencyCode: hotelFees.currency
    }

    return {
      ...convertedPrice,
      chargeable: convertedChargeable,
      hotelFees: convertedHotelFees
    }
  })
}
